import { ConditionalHelper } from './ConditionalHelper';
import { IRedirect } from '../models/helpers/redirect/IRedirect';
import { IRedirectConditional } from '../models/helpers/redirect/IRedirectConditional';
import { replacePlaceholders } from '../utils/replacePlaceholders';
import { IRedirectOptions } from '../models/helpers/redirect/IRedirectOptions';

export class RedirectHelper {
	url: URL;
	constructor(url: string, base?: string) {
		if (!base) {
			base =  window && window.location.origin;
		}
		this.url = new URL(url, base);
	}

	go(redirect: IRedirect, inputs?: object) {
		const { options } = redirect;
		const redirectPath = this.getRedirectPath(redirect, inputs);
		if (redirectPath) {
			if (options && options.target) {
				window.open(redirectPath, options.target);
			}
			else {
				document.location.href = redirectPath;
			}
		}
	}

	getRedirectPath(redirect: IRedirect | undefined, inputs?: object) {
		if (redirect) {
			const { conditionalRedirects, defaultUrl, options = {} } = redirect;
			let validRedirect: IRedirectConditional | undefined;
			if (conditionalRedirects) {
				validRedirect = conditionalRedirects.find((conditionalRedirect) => {
					const { conditional } = conditionalRedirect;
					const conditionalHelper = new ConditionalHelper(conditional);
					return conditionalHelper.matches(inputs);
				});
			}
			const url = (validRedirect && validRedirect.url) || defaultUrl;
			const redirectOptions = (validRedirect && validRedirect.options) || options;
			const replacedUrl = replacePlaceholders(inputs || {}, url);
			return this.getRedirectUrl(replacedUrl, redirectOptions);
		}
	}

	getRedirectUrl(redirectString: string, options: IRedirectOptions): string {
		const redirectUrl = new URL(redirectString, window && window.location.origin); // if url is absolute, base is ignored
		if (options.preserveOriginPath) {
			const redirectUrlSegments = redirectUrl.pathname.split('/');
			const currentUrlSegments = this.url.pathname.split('/');
			const mergedSegments = [...currentUrlSegments, ...redirectUrlSegments];
			const reducedSegments = mergedSegments.reduce((segments: string[], segment: string, segmentIndex: number) => {
				if (segmentIndex === 0 || segmentIndex > 0 && mergedSegments[segmentIndex - 1] !== segment) {
					segments.push(segment);
				}
				return segments;
			}, []);
			redirectUrl.pathname = reducedSegments.join('/');
		}

		if (options.preserveOriginHash) {
			redirectUrl.hash = this.url.hash;
		}

		if (options.preserveOriginQueryString) {
			this.url.searchParams.forEach((value, key) => {
				if (!redirectUrl.searchParams.has(key)) {
					redirectUrl.searchParams.set(key, value);
				}
			});
		}

		return redirectUrl.toString();
	}
}